import { Route } from '@angular/router';
import { authGuard } from '../../core/auth/auth.guard';
import { registrationProgressGuard } from '../../core/guards/registration-progress.guard';

export const enum AuthPath {
  SignUp = 'signup',
  SignIn = 'signin',
  SignOut = 'signout',
  ResetPassword = 'reset-password',
}

export const routes: Route[] = [
  {
    path: '',
    redirectTo: AuthPath.SignUp,
    pathMatch: 'full',
  },
  {
    path: AuthPath.SignUp,
    loadComponent: () => import('./signup/signup.component'),
    loadChildren: () => import('./signup/signup.routes').then((m) => m.routes),
    canMatch: [registrationProgressGuard()],
  },
  {
    path: AuthPath.SignIn,
    loadComponent: () => import('./signin/signin.component'),
    canMatch: [
      registrationProgressGuard(),
      authGuard({ needsAuthentication: false, redirectTo: ['/', 'account'] }),
    ],
  },
  {
    path: AuthPath.SignOut,
    loadComponent: () => import('./signout/signout.component'),
  },
  {
    path: AuthPath.ResetPassword,
    loadComponent: () => import('./reset-password/reset-password.component'),
  },
];
